import React from 'react';
import {
  MenuFolder,
  MenuItemType,
  MenuRow,
} from 'components/containers/CollapsableMenu';
import DocumentRow from 'components/rows/DocumentRow';
import { GraphQLDocumentObjectType } from 'types/documents-types';

export const createTaxesItems = (taxes: GraphQLDocumentObjectType[]) => {
  const folders: MenuFolder[] = [];
  const rows: MenuRow[] = taxes.map((tax) => ({
    type: MenuItemType.Row,
    row: (
      <DocumentRow
        title={tax.documentLabel}
        uri={tax.documentUri}
      />
    ),
  }));

  folders.push({
    type: MenuItemType.Folder,
    title: '1099 Tax Forms',
    rows,
  });

  return folders;
};
